import React from 'react'
import { IconProps } from '../types'

export default function CopyIcon({
    className = 'h-[13px] w-[13px]',
    stroke = 'black',
    strokeOpacity = 0.4,
    strokeWidth = 0.875,
    ...props
}: IconProps & { strokeOpacity?: number }) {
    return (
        <svg
            width="13"
            height="13"
            viewBox="0 0 13 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path
                d="M9.61133 2.625L9.625 1.96875C9.62385 1.56299 9.46215 1.17418 9.17523 0.887268C8.88832 0.600353 8.49951 0.438654 8.09375 0.4375H2.1875C1.72379 0.438871 1.27947 0.623685 0.951577 0.951577C0.623685 1.27947 0.438871 1.72379 0.4375 2.1875V8.09375C0.438654 8.49951 0.600353 8.88832 0.887268 9.17523C1.17418 9.46215 1.56299 9.62385 1.96875 9.625H2.625M4.18359 2.625H10.2539C11.1147 2.625 11.8125 3.32281 11.8125 4.18359V10.2539C11.8125 11.1147 11.1147 11.8125 10.2539 11.8125H4.18359C3.32281 11.8125 2.625 11.1147 2.625 10.2539V4.18359C2.625 3.32281 3.32281 2.625 4.18359 2.625Z"
                stroke={stroke}
                strokeOpacity={strokeOpacity}
                strokeWidth={strokeWidth}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}
